import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/roboto';
import '@circles/tokens/css';
import './styles/base.css';
import './styles/app.css';
import './styles/shell.css';
import { App } from './App';
import { readHash } from './shell/presets';

readHash();
// Review links: changing the hash by hand (or from a script) jumps to that state.
window.addEventListener('hashchange', readHash);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
